import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort } from '@angular/material';
import { MassiveModeComponent } from './massive-mode-popup/massive-mode.component';

import { Task, TasksService } from 'src/app/services/api/tasks/tasks.service';
import { BehaviorSubject, combineLatest, from, interval, Observable, of, Subscription } from 'rxjs';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DomainService } from 'src/app/services/api/domains/domains.service';
import { TASK_CUSTOM_SEARCH_KEYS, TASK_TYPES } from 'src/app/utils/Constants';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';
import { catchError, concatMap, debounceTime, delay, delayWhen, filter, map, startWith, switchMap, tap, toArray } from 'rxjs/operators';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AppService } from 'src/app/app.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { MessageObject } from 'src/app/models/message/message-object.model';
import { TasksOperationObject } from 'src/app/models/tasks/task/tasks-operation.model';
import { TaskService } from 'src/app/services/api/tasks/specific-task/task.service';
import { KeycloakService } from 'keycloak-angular';
import { UtilsService } from 'src/app/services/utils/utils.service';
import moment, { relativeTimeRounding } from 'moment';
import { ConfirmationDialogComponent } from 'src/app/core/components/confirmation-dialog.component';
import { OrdersService } from 'src/app/services/api/orders/orders.service';
import { ProductService } from 'src/app/services/api/product/product.service';
import { Role } from 'src/app/utils/Role';
import { TaskManagementService } from 'src/app/services/api/taskmanagement/taskmanagement.service';
import { MyTaskComponent } from './my-tasks-popup/my-tasks.component'
import { MyUnassignedTaskComponent } from './my-unassigned-tasks-popup/my-unassigned-tasks.component'

interface Filter {
  _key: string;
  _value: string;
}
interface Index {
  firstIndex: number;
  lastIndex: number;
}

enum MasterToggleState {
  CHECKED, INDETERMINATE, NOT_CHECKED
}

export class SearchMyTasksObject {
  constructor(
    private page: number,
    private size: number,
    private userId: string,
    private roles: string[]
    ) {

    this.page = page;
    this.size = size;
    this.userId = userId
    this.roles = roles;

    }
}

export class SearchObject {
  private page: number;
  private size: number;
  private sort: any[];

  constructor(private filters: Filter[]) {
    this.filters = filters;
  }

  setPage(page: number) {
    this.page = page;
  }

  setSize(size: number) {
    this.size = size;
  }

  setSort(sortFields: any) {
    this.sort = sortFields;
  }

  setFilters(filters: Filter[]) {
    this.filters = filters;
  }

  getFilters(): Filter[] {
    return this.filters;
  }
}

interface FormObject {
  customSearchKey: string;
  customSearchValue: string;
  taskType: string;
  isp: string;
  fromDate: string;
  toDate: string;
}

@Component({
  selector: 'app-tasks-body',
  templateUrl: './tasks-body.component.html',
  styleUrls: ['./tasks-body.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class TasksBodyComponent implements OnInit, AfterViewInit, OnDestroy {

  [x: string]: any;

  dataSource = new MatTableDataSource<Task>();
  expandedElement: Task | null;

  MASSIVE_MODE_LIMIT: number;
  PAGE_SIZE: number;

  limitExceeded = false;
  //selection: SelectionModel<Task>;

  masterToggleState: MasterToggleState;
  masterToggleStates: typeof MasterToggleState;

  doDelay: boolean;
  afterActionMessage: string;

  @ViewChild(MatPaginator, null) paginator: MatPaginator;
  @ViewChild(MatSort, null) sort: MatSort;

  basicColumns: string[] = [
    'createdon', 'domain', 'activity', 'businesscrmid',
    'taskType', 'errorCode', 'errorDescription', 'idProceso','actualOwnerId', 'queue'
  ];

  massiveColumns: string[] = [
    'selected', 'createdon', 'domain', 'activity', 'businesscrmid',
    'taskType', 'errorCode', 'errorDescription', 'idProceso'
  ];

  displayedColumns: string[];

  data: Task[] = [];
  resultsLength = 0;

  dialogRef: MatDialogRef<MassiveModeComponent>;

  csvLoading = false;
  loading = false;

  searchGroup: FormGroup;
  combos: any;

  paramsObject: any;
  lastSearchObject: SearchObject;

  private searchSubject = new BehaviorSubject<void>(null);

  private subscriptions = new Subscription();
  selectedTasks: Array<Task>;
  showMassiveMode: boolean;
  totalTasks: number;
  appData: any;

  masterToggleDisabled: boolean;

  userId: string;
  userTaskManagementRoles: string[]= [null];
  alowedUsers: string[]= [null];

  pageSize: number;
  pageIndex: number;
  sortActive: string;
  sortDirection: string;

  firstSearch: boolean;

  hasFullRelaunchRole: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private breadcrumbsService: BreadcrumbsService,
    private domainService: DomainService,
    public dialog: MatDialog,
    private tasksService: TasksService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private appService: AppService,
    private taskService: TaskService,
    private notificationsService: NotificationsService,
    private keycloakService: KeycloakService,
    private ordersService : OrdersService,
    private productService : ProductService,
    private taskmanagementService : TaskManagementService,
    private utilsService: UtilsService) {

  }

  ngOnInit() {
    this.displayedColumns = this.basicColumns;
    const keycloakTokenParsed = this.keycloakService.getKeycloakInstance().tokenParsed;
    this.userId = keycloakTokenParsed['preferred_username'];
    this.userTaskManagementRoles = [] 
      if(keycloakTokenParsed['resource_access']['task-management']){
        this.userTaskManagementRoles = keycloakTokenParsed['resource_access']['task-management'].roles;
      }
    this.alowedUsers.push(this.userId);
    this.hasFullRelaunchRole = this.keycloakService.getUserRoles().includes(Role.FullRelaunch);

    this.appData = this.appService.settings;

    this.MASSIVE_MODE_LIMIT = this.appData.massiveModeLimit;

    this.masterToggleDisabled = false;

    this.selectedTasks = new Array<Task>();

    this.masterToggleState = MasterToggleState.NOT_CHECKED;
    this.masterToggleStates = MasterToggleState;

    this.combos = {
      customSearchKey: [],
      taskType: [],
      domain: [],
      queues: []
    };

    this.doDelay = false;

    this.combos.customSearchKey = [{ name: 'Sin filtro', value: null }].concat(TASK_CUSTOM_SEARCH_KEYS);
    this.combos.taskType = [{ name: 'Cualquiera', value: null }].concat(TASK_TYPES);

    this.breadcrumbsService.sendBreadcrumbs(
      {
        breadcrumbs:
          [
            { title: 'Tareas', url: 'provision/tasks/search' }
          ]
      }
    );

    this.pageIndex = 0;
    this.pageSize = 20;
    this.sortActive = 'createdon';
    this.sortDirection = 'desc';

    this.combos.domain = [{ name: 'Cualquiera', value: null }];
    this.domainService.getDomainNameTypes().subscribe(
      (data) => {
        for (const domain of data._embedded.domainNameTypes) {
          this.combos.domain.push({ name: domain.name, value: domain.name });
        }
      }
    );

    this.combos.queue = [];
    this.taskmanagementService.getQueues().subscribe(
      (data) => {
        for (const queue of data) {
          this.combos.queue.push({ name: queue.name, value: queue.name });
        }
      }
    );

    this.searchGroup = this.formBuilder.group({
      customSearchKey: this.formBuilder.control(null),
      customSearchValue: this.formBuilder.control(''),
      taskType: this.formBuilder.control(null),
      domain: this.formBuilder.control(null),
      fromDate: this.formBuilder.control(null),
      toDate: this.formBuilder.control(null),
      queue: this.formBuilder.control(null),
    });

    this.firstSearch = true;
    this.checkParams();
    this.checkPageAndSort();
  }

  ngAfterViewInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.paginator.pageIndex = params['page'] ? params['page'] : this.pageIndex;
    });
    this.updateMassiveModePagingVariables();
    this.subscriptions.add(
      combineLatest(
        this.searchGroup.valueChanges
          .pipe(
            startWith(this.searchGroup.value),
            debounceTime(500),
            map(
              (formObject: FormObject) => {
                return new SearchObject(
                  Object.entries(formObject).filter(
                    ([key, value]) => {
                      // Si es el buscador de texto
                      if (key.includes('customSearchValue')) {
                        return !!value && this.customSearchKeyControl.value !== null;
                      } 
                      // Si es el combo de queue (Evitamos que pase si está vacío o es 'Cualquiera' [null])
                      else if (key === 'queue') {
                        return Array.isArray(value) && value.length > 0 && value[0] !== null;
                      } 
                      // Para el resto de los filtros
                      else {
                        return !!value && !key.includes('customSearchKey');
                      }
                    }
                  ).map(([key, value]) => {
                    if (key.includes('customSearchValue')) {
                      return { _key: this.customSearchKeyControl.value, _value: value, _operation: null };
                    } else if (key === 'queue') {
                      // Ya sabemos que es un array válido por el filter, lo unimos
                      return { _key: 'queue_in', _value: (value as Array<any>).join(','), _operation: null };
                    } else {
                      return { _key: key, _value: value, _operation: null };
                    }
                  })
                );
              }
            ),
            tap(() => {
              if (!this.firstSearch) {
                this.paginator.firstPage()
              }
            }),
          ),
        this.sort.sortChange
          .pipe(
            startWith({
              active: 'createdon',
              direction: 'desc'
            } as Sort),
            tap(() => {
              if (!this.firstSearch) {
                this.paginator.firstPage()
              }
            }),
          ),
        this.paginator.page
          .pipe(
            startWith({
              pageIndex: this.paginator.pageIndex,
              previousPageIndex: 0,
              pageSize: this.paginator.pageSize,
              length: this.paginator.length
            } as PageEvent),
          ),
        this.searchSubject.asObservable(),
      )
        .pipe(
          debounceTime(50),
          switchMap(([search, sort, page]: [SearchObject, Sort, PageEvent, void]) => {
            this.loading = true;
            this.updateParamsObject();
            this.updateUrl();
            search.setPage(page.pageIndex);
            search.setSize(page.pageSize);
            if (sort.active && sort.direction) {
              if (sort.active == "actualOwnerId") {
                sort.active = "actualOwner_Id"
              }
              search.setSort([{
                _key: sort.active,
                _value: sort.direction.toUpperCase()
              }]);
            } else {
              search.setSort([]);
            }
            return this.tasksService
              .getTasks(search).pipe(
                catchError(() => of({
                  elements: [],
                  total: 0,
                }),
                ),
              );
          }),
          delayWhen(() => this.doDelay ? interval(3000) : interval(0)),
          map(data => {
            this.loading = false;
            this.firstSearch = false;
            this.resultsLength = data.total;
            if (this.doDelay) this.paginator.length = data.total;
            return data.elements;
          }),
          catchError(() => {
            this.resultsLength = 0;
            return of([]);
          }),
        )
        .subscribe((data) => {
          this.data = data;
          this.updateRowCheckboxes();
          this.checkMasterToggle(false);
          if (this.doDelay) {
            this.notificationsService.showNotification(this.afterActionMessage, NotificationLevel.SUCCESS);
            this.paginator.firstPage();
          }
          this.doDelay = false;
        })
    );
  }

  private updateParamsObject() {
    this.paramsObject = {};
    this.lastSearchObject = new SearchObject([]);

    if (this.paginator) {
      this.paramsObject['page'] = this.paginator.pageIndex.toString();
      this.lastSearchObject.setPage(this.paginator.pageIndex);
    }

    if (this.paginator && this.paginator.pageSize) {
      this.paramsObject['size'] = this.paginator.pageSize.toString();
      this.lastSearchObject.setSize(this.paginator.pageSize);
    }

    if (this.sort.active) {
      this.paramsObject['sort'] = this.sort.active + ',' + this.sort.direction;
      this.lastSearchObject.setSort([{ _key: this.sort.active, _value: this.sort.direction.toUpperCase() }]);
    }

    for (const param in this.searchGroup.controls) {
        const controlValue = this.searchGroup.controls[param].value;

        // Solo procesamos si tiene un valor válido (no indefinido, no nulo y no string vacío)
        if (controlValue !== undefined && controlValue !== null && controlValue !== '') {
          
          // Tratamiento especial para 'queue'
          if (param === 'queue') {
            // Solo lo añadimos si es un array con elementos y no es el valor nulo ('Cualquiera')
            if (Array.isArray(controlValue) && controlValue.length > 0 && controlValue[0] !== null) {
              const stringValue = controlValue.join(',');
              this.paramsObject['queue_in'] = stringValue;
              this.lastSearchObject.getFilters().push({ _key: 'queue_in', _value: stringValue });
            }
            continue; // Pasamos al siguiente parámetro (no ejecutamos lo de abajo)
          }

          // Para el resto de campos (fechas, textos, etc.)
          this.paramsObject[param] = controlValue;
          this.lastSearchObject.getFilters().push({ _key: param, _value: controlValue });
        }
    }
  }

  private checkParams() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (this.firstSearch) {
        this.searchGroup.controls['customSearchKey'].setValue(params['customSearchKey'] ? params['customSearchKey'] : this.searchGroup.controls['customSearchKey'].value);
        this.searchGroup.controls['customSearchValue'].setValue(params['customSearchValue'] ? params['customSearchValue'] : this.searchGroup.controls['customSearchValue'].value);
        this.searchGroup.controls['taskType'].setValue(params['taskType'] ? params['taskType'] : this.searchGroup.controls['taskType'].value);
        this.searchGroup.controls['domain'].setValue(params['domain'] ? params['domain'] : this.searchGroup.controls['domain'].value);
        this.searchGroup.controls['fromDate'].setValue(params['fromDate'] ? new Date(params['fromDate']) : this.searchGroup.controls['fromDate'].value);
        this.searchGroup.controls['toDate'].setValue(params['toDate'] ? new Date(params['toDate']) : this.searchGroup.controls['toDate'].value);
        // Leemos 'queue_in' de los parámetros de la URL
        if (params['queue_in']) {
          // Lo convertimos de un string "cola1,cola2" a un array ["cola1", "cola2"] para el <mat-select>
          const queueArray = typeof params['queue_in'] === 'string' ? params['queue_in'].split(',') : params['queue_in'];
          this.searchGroup.controls['queue'].setValue(queueArray);
        } else {
          this.searchGroup.controls['queue'].setValue(this.searchGroup.controls['queue'].value);
        }
      }
    });
  }

  private checkPageAndSort() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (this.firstSearch) {
        this.paginator.pageIndex = params['page'] ? params['page'] : this.pageIndex;
        this.pageSize = params['size'] ? params['size'] : this.pageSize;
        this.sortActive = params['sort'] && params['sort'].split(',') ? params['sort'].split(',')[0] : this.sortActive;
        this.sortDirection = params['sort'] && params['sort'].split(',') ? params['sort'].split(',')[1] : this.sortDirection;
      }
    });
  }

  private updateUrl() {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: this.paramsObject,
      skipLocationChange: false
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  resetForm() {
    this.searchGroup.reset();
  }

  search() {
    this.searchSubject.next();
    this.updateMassiveModePagingVariables();
  }

  updateAfterAction() {
    this.doDelay = true;
    this.cleanSelectedTasks();
    this.resetForm();
    this.data = [];
    this.paginator.length = 0;
    this.searchSubject.next();
  }

  navigateToDetail(row: Task) {
    window.open(`${this.appData.baseUrl}${this.appData.basePath}/provision/tasks/detail?id=${row.idTask}`, '_blank');
  }

  get customSearchKeyControl(): FormControl {
    return this.searchGroup.get('customSearchKey') as FormControl;
  }

  get customSearchValueControl(): FormControl {
    return this.searchGroup.get('customSearchValue') as FormControl;
  }

  get taskTypeControl(): FormControl {
    return this.searchGroup.get('taskType') as FormControl;
  }

  get domainControl(): FormControl {
    return this.searchGroup.get('domain') as FormControl;
  }
  get queueControl(): FormControl {
    return this.searchGroup.get('queue') as FormControl;
  }

  get fromDateControl(): FormControl {
    return this.searchGroup.get('fromDate') as FormControl;
  }

  get toDateControl(): FormControl {
    return this.searchGroup.get('toDate') as FormControl;
  }

  public changeMassiveMode() {
    this.showMassiveMode = !this.showMassiveMode;
    if (this.showMassiveMode) {
      this.displayedColumns = this.massiveColumns;
      this.updateRowCheckboxes();
    }
    else {
      this.displayedColumns = this.basicColumns;
    }
  }

  private updateRowCheckboxes() {
    for (const task of this.data) {
      if (this.selectedTasks.some(selectedTask => selectedTask.idProceso === task.idProceso)) {
        task.selected = true;
      }
      else {
        task.selected = false;
      }
    }
  }

  public relaunch() {
    this.dialogRef = this.dialog.open(MassiveModeComponent, {
      width: '850px',
      data: {
        action: 'relanzar',
        numberOfTasks: this.selectedTasks.length
      }
    });

    this.dialogRef.afterClosed().subscribe((massiveModeObject) => {
      if (massiveModeObject.action) {
        this.taskService.relaunchTasks(this.userId,
          new TasksOperationObject(new MessageObject(massiveModeObject.comments), this.selectedTasks
          )).subscribe(
            (data) => {
              this.afterActionMessage = 'La(s) tarea(s) se ha(n) relanzado correctamente';
              this.notificationsService.showNotification('Recargando tareas...', NotificationLevel.INFO);
              this.updateAfterAction();
            },
            (error) => {
              this.notificationsService.showNotification('Ha habido un problema al relanzar la(s) tarea(s)', NotificationLevel.ERROR);
            }
          );
      }
    });
  }

  public bypass() {
    this.dialogRef = this.dialog.open(MassiveModeComponent, {
      width: '850px',
      data: {
        action: 'saltar',
        numberOfTasks: this.selectedTasks.length
      }
    });

    this.dialogRef.afterClosed().subscribe((massiveModeObject) => {
      if (massiveModeObject.action) {
        this.taskService.bypassTasks(this.userId,
          new TasksOperationObject(new MessageObject(massiveModeObject.comments), this.selectedTasks
          )).subscribe(
            (data) => {
              this.afterActionMessage = 'La(s) tarea(s) se ha(n) saltado correctamente';
              this.notificationsService.showNotification('Recargando tareas...', NotificationLevel.INFO);
              this.updateAfterAction();
            },
            (error) => {
              this.notificationsService.showNotification('Ha habido un problema al saltar la(s) tarea(s)', NotificationLevel.ERROR);
            }
          );
      }
    });
  }

  public confirmationDialogFullRelaunch(){
    const stateDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        text: 'Precaución, el FullRelauch solo aplica a órdenes de móvil de MM. ¿Desea continuar?',
      },
      disableClose: true,
      minWidth: 150,
      minHeight: 150,
    });

    stateDialog.afterClosed().subscribe((value) => {
      if(value){
        this.checkTasks();
      }
    });
  }

  public fullRelaunch(validTasks : Task[]) {

    this.dialogRef = this.dialog.open(MassiveModeComponent, {
      width: '850px',
      data: {
        action: 'realizar fullRelaunch',
        numberOfTasks: validTasks.length,
        validTasks: validTasks
      }
    });

    this.dialogRef.afterClosed().subscribe((massiveModeObject) => {
      if (massiveModeObject.action) {
        this.taskService.fullRelaunchTasks(this.userId,
          new TasksOperationObject(new MessageObject(massiveModeObject.comments), validTasks
          )).subscribe(
            (data) => {
              this.afterActionMessage = 'A la(s) tarea(s) se le(s) ha aplicado FullRelaunch correctamente';
              this.notificationsService.showNotification('Aplicando FullRelaunch a tareas...', NotificationLevel.INFO);
              this.updateAfterAction();
            },
            (error) => {
              this.notificationsService.showNotification('Ha habido un problema aplicando FullRelaunch a la(s) tarea(s)', NotificationLevel.ERROR);
            }
          );
      }
    });
  }




  public checkFullRelaunchableTasks(tasks: Task[]): Observable<Task[]> {
    const validTasks: Task[] = [];

    // Devolvemos el Observable
    return from(tasks)
      .pipe(
        concatMap(task =>
          this.ordersService.getServiceOrder(task.orderId).pipe(
            filter(order => this.appService.settings.fullRelaunchRfs.includes(order.specification)),
            switchMap(order =>
              this.productService.getProductByRFS(order.serviceRef).pipe(
                filter(product => !product.template.toUpperCase().includes('COMP')),
                // En caso de éxito, añadimos la tarea a las tareas válidas
                tap(product => validTasks.push(task)),
                catchError(() => of(null))
              )
            ),
            catchError(() => of(null))
          )
        ),
        toArray(),
        map(() => validTasks)
      );
  }


 public checkTasks(){
    this.checkFullRelaunchableTasks(this.selectedTasks).subscribe(
      validTasks => {
      this.fullRelaunch(validTasks);
    });

  }


  onDiffTotalTask(totalTasks: number) {
    this.totalTasks = totalTasks;
  }

  public cleanSelectedTasks() {
    this.masterToggle(true);
    this.selectedTasks = [];
  }

  public selectRow(row: Task) {
    if (((this.selectedTasks.length + 1) > this.MASSIVE_MODE_LIMIT) && row.selected) {
      return;
    }
    if (row.selected) {
      let contains = false;
      for (const task of this.selectedTasks) {
        if (task.idProceso === row.idProceso) { contains = true; }
      }
      if (!contains) {
        this.selectedTasks.push(row);
      }
    }

    if (!row.selected) {
      let contains = false;
      for (const task of this.selectedTasks) {
        if (task.idProceso === row.idProceso) { contains = true; }
      }
      if (contains) {
        const oldList = this.selectedTasks;
        this.selectedTasks = new Array<Task>();
        for (const task of oldList) {
          if (task.idProceso !== row.idProceso) { this.selectedTasks.push(task); }
        }
      }
    }
    this.checkMasterToggle(false);
  }

  isAllSelected() {
    let allSelected = true;
    this.data.forEach((task) => {
      if (!task.selected && this.alowedUsers.includes(task.actualOwnerId)) {
        allSelected = false;
      }
    });
    return allSelected;
  }

  isSomeoneSelected() {
    let someoneSelected = false;
    this.data.forEach((task) => {
      if (task.selected) { someoneSelected = true; }
    });
    return someoneSelected;
  }

  masterToggle(doClean: boolean) {
    if (this.limitExceeded) {
      this.limitExceeded = false;
      return;
    }
    if (this.isAllSelected() || doClean) {
      this.data.forEach((task) => {
        this.selectedTasks.splice(this.selectedTasks.findIndex(selectedTask => selectedTask.idProceso === task.idProceso), 1);
        task.selected = false;
      });
    } else {
      this.data.forEach((task) => {
        if (this.alowedUsers.includes(task.actualOwnerId) &&
            this.selectedTasks.findIndex(selectedTask => selectedTask.idProceso === task.idProceso) === -1) {
          if ((this.selectedTasks.length + 1) <= this.MASSIVE_MODE_LIMIT) {
            task.selected = true;
            this.selectedTasks.push(task);
          }
        }
      });

    }
    this.checkMasterToggle(doClean);
  }

  private updateMassiveModePagingVariables() {
    this.PAGE_SIZE = this.paginator.pageSize;
  }

  public checkMasterToggle(doClean: boolean) {
    if (this.isAllSelected() && !doClean) {
      this.masterToggleState = this.masterToggleStates.CHECKED;
    } else if (this.isSomeoneSelected() && !this.isAllSelected() && !doClean) {
      this.masterToggleState = this.masterToggleStates.INDETERMINATE;
    } else {
      this.masterToggleState = this.masterToggleStates.NOT_CHECKED;
    }
    if (this.selectedTasks.length === this.MASSIVE_MODE_LIMIT && this.masterToggleState === this.masterToggleStates.NOT_CHECKED) {
      this.masterToggleDisabled = true;
    } else {
      this.masterToggleDisabled = false;
    }
  }

  public getTasksCsv() {
    this.csvLoading = true;
    this.notificationsService.showNotificationWithDuration('El fichero está siendo generado....', NotificationLevel.INFO, 30000);
    const fileDownloadPromise = this.tasksService.getTasksCsv(this.lastSearchObject);
    this.utilsService.downloadFileV2(fileDownloadPromise, () => this.finish());
  }

  private finish(): void {
		this.csvLoading = false;
	}

  getMyTasks() {
    let userId = this.userId
    let userRoles = this.userTaskManagementRoles
      const matDialogRef = this.dialog.open(MyTaskComponent, {
      data: {
        userId,
        userRoles
      },
      disableClose: true,
      //hasBackdrop: true,
      //width: '75%',
      //maxHeight: '70vh',
      maxHeight: '90%',
      //restoreFocus: false,
      //autoFocus: false
    });

  }
  getMyUnassignedTasks() {

    let userId = this.userId
    let userRoles = this.userTaskManagementRoles
      const matDialogRef = this.dialog.open(MyUnassignedTaskComponent, {
      data: {
        userId,
        userRoles
      },
      disableClose: true,
      //hasBackdrop: true,
      //width: '75%',
      maxHeight: '90%',
      //restoreFocus: false,
      //autoFocus: false
    });
  }

}


